var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadoutSelectOption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61149",
    "data-name": "Group 61149",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 325.115,
    height: 180.394,
    viewBox: "0 0 325.115 180.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -24.308,
    y1: -0.433,
    x2: -21.528,
    y2: 1.195,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_221341",
    "data-name": "Path 221341",
    d: "M273.738,109.051h0c0-12.047-10.617-21.814-23.713-21.814H223.377c-13.1,0-23.713-9.767-23.713-21.814h0c0-12.047,10.617-21.814,23.713-21.814h56.8c13.1,0,23.712-9.767,23.712-21.814h0c0-12.047-10.617-21.814-23.712-21.814H94.37c-13.1,0-23.713,9.767-23.713,21.814h0c0,12.047-10.617,21.814-23.713,21.814H23.713C10.617,43.609,0,53.376,0,65.424H0C0,77.471,10.617,87.238,23.713,87.238H68.4c13.1,0,23.713,9.767,23.713,21.814h0c0,12.047-10.617,21.814-23.713,21.814H45.387c-13.1,0-23.713,9.767-23.713,21.814h0c0,12.047,10.617,21.814,23.713,21.814H301.4c13.1,0,23.713-9.767,23.713-21.814h0c0-12.048-10.617-21.814-23.713-21.814h-3.951c-13.1,0-23.713-9.767-23.713-21.814Z",
    transform: "translate(0 0.02)",
    fill: "#f1f1f1",
    opacity: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_89437634_Seamless_Shipping_Transportation_and_Logistics_Integration",
    "data-name": "89437634_Seamless Shipping Transportation and Logistics Integration",
    transform: "translate(51.193 36.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221434",
    "data-name": "Path 221434",
    d: "M1142.205,1078.333a1.934,1.934,0,0,1,1.946,1.923V1206.9a1.935,1.935,0,0,1-1.946,1.922h-66.532a1.935,1.935,0,0,1-1.946-1.922V1080.256a1.934,1.934,0,0,1,1.946-1.923Z",
    transform: "translate(-928.322 -1064.527)",
    fill: "#b5b5b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221435",
    "data-name": "Path 221435",
    d: "M1154.159,1097.186a2.563,2.563,0,0,0-2.574-2.551h-9.126a2.588,2.588,0,0,0-1.846.77l-2.1,2.136a2.587,2.587,0,0,1-1.844.77h-29.99a2.587,2.587,0,0,1-1.844-.77l-2.105-2.136a2.586,2.586,0,0,0-1.842-.77h-9.128a2.563,2.563,0,0,0-2.576,2.551v83.6h64.979v-83.6Z",
    transform: "translate(-941.053 -1077.957)",
    fill: "#f0f0f1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221436",
    "data-name": "Path 221436",
    d: "M1089.182,1583.686v35.855a2.566,2.566,0,0,0,2.576,2.556h59.829a2.565,2.565,0,0,0,2.574-2.556v-35.855Z",
    transform: "translate(-941.055 -1480.854)",
    fill: "#f0f0f1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61136",
    "data-name": "Group 61136",
    transform: "translate(191.507 44.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221437",
    "data-name": "Path 221437",
    d: "M1351.535,1253.414c0,1.6-2.9,7.47-2.9,7.47s-2.9-5.872-2.9-7.47a2.9,2.9,0,0,1,5.808,0Z",
    transform: "translate(-1345.727 -1250.52)",
    fill: "#b5b5b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221438",
    "data-name": "Path 221438",
    d: "M1358.519,1260.92a2.275,2.275,0,1,1-2.275-2.25A2.263,2.263,0,0,1,1358.519,1260.92Z",
    transform: "translate(-1353.34 -1257.988)",
    fill: "#f0f0f1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_221441",
    "data-name": "Path 221441",
    d: "M1267.054,1363.053H1250.94V1360.5h14.914l7.62-9.119,1.969,1.63Z",
    transform: "translate(-1074.316 -1289.478)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221442",
    "data-name": "Path 221442",
    d: "M1109.206,1130.758l3.9-9.793,41.06,3.479V1121.9l-40.079-3.4,1.39-3.493h-2.748l-1.3,3.268-22.241-1.885v2.545l21.262,1.8-3.9,9.793-17.365-1.471v2.544l16.386,1.388-6.785,17.052,9.8,17.918-11.025,20.9,2.263,1.176,10.23-19.388,3.813,6.977h40.3v-2.535h-38.778l-13.785-25.214,6.629-16.657,45.935,3.892v-2.544Z",
    transform: "translate(-941.055 -1094.744)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221443",
    "data-name": "Path 221443",
    d: "M1145.877,1477.421v-13.96h-2.554V1477.3l-54.141-2.482v2.532l64.979,2.979V1477.8Z",
    transform: "translate(-941.055 -1381.809)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221444",
    "data-name": "Path 221444",
    d: "M1128.2,1132.946c.017-.189.029-.379.029-.572a6.1,6.1,0,0,0-1.171-3.593l25.173-34.062a2.551,2.551,0,0,0-.646-.085h-2.458l-23.966,32.429a6.235,6.235,0,0,0-9.389,5.312c0,.007,0,.015,0,.023h-26.594v2.531h27.153a6.239,6.239,0,0,0,3.978,3.383l-14.072,42.478h2.688l14.021-42.318a6.244,6.244,0,0,0,4.481-3.08l26.729,13.1v-2.824Z",
    transform: "translate(-941.054 -1077.957)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221445",
    "data-name": "Path 221445",
    d: "M1258.691,1295.576a3.68,3.68,0,1,1,3.63-3.68A3.659,3.659,0,0,1,1258.691,1295.576Z",
    transform: "translate(-1077.711 -1237.437)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61139",
    "data-name": "Group 61139",
    transform: "translate(137.963 117.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h24.685v27.1h-24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1112.121 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_221480",
    "data-name": "Path 221480",
    d: "M1031.485,1548.031h17.243v20.64h-17.243Z",
    transform: "translate(-893.522 -1451.48)",
    fill: "#dddbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221481",
    "data-name": "Path 221481",
    d: "M1093.3,1565.349h5.264v3.23H1093.3Z",
    transform: "translate(-944.45 -1465.747)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221482",
    "data-name": "Path 221482",
    d: "M1201.485,1595.911h35.756v39.308h-35.756Z",
    transform: "translate(-1033.574 -1490.926)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221483",
    "data-name": "Path 221483",
    d: "M1328.212,1608.136h10.89v5.206h-10.89Z",
    transform: "translate(-1137.976 -1500.997)",
    fill: "#aaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221484",
    "data-name": "Path 221484",
    d: "M1473.485,1443.084h21.781v66.232h-21.781Z",
    transform: "translate(-1257.656 -1365.022)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221485",
    "data-name": "Path 221485",
    d: "M1554.879,1460.4h4.538v16.873h-4.538Z",
    transform: "translate(-1324.712 -1379.29)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221488",
    "data-name": "Path 221488",
    d: "M1430.212,1649.914h25.774v29.795h-25.774Z",
    transform: "translate(-1222.007 -1535.415)",
    fill: "#dddbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221489",
    "data-name": "Path 221489",
    d: "M1537.364,1661.12h4.719v9.334h-4.719Z",
    transform: "translate(-1310.282 -1544.647)",
    fill: "#aaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61101",
    "data-name": "Group 61101",
    transform: "translate(7.377 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221318",
    "data-name": "Path 221318",
    d: "M1510.269,2072.466h129.676v-2.216H1510.269Z",
    transform: "translate(-1509.664 -1962.373)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221319",
    "data-name": "Path 221319",
    d: "M1510.269,1538.564H1641.2v-2.125H1510.269Z",
    transform: "translate(-1509.664 -1472.523)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221320",
    "data-name": "Path 221320",
    d: "M1510.269,1131.659H1640.49v-1.95H1510.269Z",
    transform: "translate(-1509.664 -1099.274)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221321",
    "data-name": "Path 221321",
    d: "M1495.741,897.293h2.242V760.473c0-.747-.3-1.353-.672-1.353h-1.57Z",
    transform: "translate(-1495.741 -759.12)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221322",
    "data-name": "Path 221322",
    d: "M3181.1,909.237h2.475V766.423h-1.733c-.41,0-.742.647-.742,1.446Z",
    transform: "translate(-3051.474 -766.119)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61140",
    "data-name": "Group 61140",
    transform: "translate(3.838 3.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61148",
    "data-name": "Group 61148",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61140-2",
    "data-name": "Group 61140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-2",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h24.685v27.1h-24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-2",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1112.121 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61144",
    "data-name": "Group 61144",
    transform: "translate(98.889 32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-3",
    "data-name": "Path 221478",
    d: "M1056.17,1665.195h-24.685v27.1h24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-3",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61141",
    "data-name": "Group 61141",
    transform: "translate(27.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-4",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h30.647v27.1h-30.647Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-4",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1106.159 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61145",
    "data-name": "Group 61145",
    transform: "translate(65.575 32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-5",
    "data-name": "Path 221478",
    d: "M1062.132,1665.195h-30.647v27.1h30.647Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-5",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61142",
    "data-name": "Group 61142",
    transform: "translate(61.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-6",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195h24.685v27.1h-24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-6",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1112.121 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61146",
    "data-name": "Group 61146",
    transform: "translate(37.516 32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-7",
    "data-name": "Path 221478",
    d: "M1056.17,1665.195h-24.685v27.1h24.685Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-7",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61143",
    "data-name": "Group 61143",
    transform: "translate(89.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-8",
    "data-name": "Path 221478",
    d: "M1031.485,1665.195H1065.9v27.1h-34.416Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-8",
    "data-name": "Path 221479",
    d: "M1129.364,1681.494h4.719v12.564h-4.719Z",
    transform: "translate(-1102.39 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61147",
    "data-name": "Group 61147",
    transform: "translate(0 32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221478-9",
    "data-name": "Path 221478",
    d: "M1065.9,1665.195h-34.416v27.1H1065.9Z",
    transform: "translate(-1031.485 -1665.195)",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221479-9",
    "data-name": "Path 221479",
    d: "M1134.083,1681.494h-4.719v12.565h4.719Z",
    transform: "translate(-1126.641 -1678.623)",
    fill: "#e3e3e3",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61134",
    "data-name": "Group 61134",
    transform: "translate(169.726 117.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221490",
    "data-name": "Path 221490",
    d: "M1211.788,1665.195h24.685v27.1h-24.685Z",
    transform: "translate(-1211.788 -1665.195)",
    fill: "#dddbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221491",
    "data-name": "Path 221491",
    d: "M1221.061,1673.344h5.264v3.051h-5.264Z",
    transform: "translate(-1219.428 -1671.908)",
    fill: "#aaa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61133",
    "data-name": "Group 61133",
    transform: "translate(0 68.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61120",
    "data-name": "Group 61120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30222",
    "data-name": "Rectangle 30222",
    width: 96.892,
    height: 8.889,
    transform: "translate(32.712 54.757)",
    fill: "#7d7d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221347",
    "data-name": "Path 221347",
    d: "M1234.622,2728.492h1.33a1.514,1.514,0,0,0,1.514-1.515V2719.6h-2.844v8.889Z",
    transform: "translate(-1105.729 -2664.846)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221348",
    "data-name": "Path 221348",
    d: "M1197.944,1916.593c0-2.118,2.238-3.892,4.665-3.892h91.432a4.145,4.145,0,0,1,4.351,3.892v48.186a4.171,4.171,0,0,1-4.351,3.924h-91.432c-2.427,0-4.665-1.806-4.665-3.924v-48.186Z",
    transform: "translate(-1164.165 -1912.701)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221349",
    "data-name": "Path 221349",
    d: "M1234.622,1950.281a3.746,3.746,0,0,1,4.037-3.523h87.956c2.334,0,4.635,1.584,4.635,3.523v44.046c0,1.938-2.3,3.811-4.635,3.811h-87.956a3.97,3.97,0,0,1-4.037-3.811Z",
    transform: "translate(-1198.957 -1944.448)",
    fill: "#dddbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221350",
    "data-name": "Path 221350",
    d: "M2687.417,2222.768l6.006-18.526a1.094,1.094,0,0,1,1.073-.742h24.144v43.913h-32.646Z",
    transform: "translate(-2685.395 -2183.767)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221351",
    "data-name": "Path 221351",
    d: "M2780.554,2747.048a2.019,2.019,0,0,1,1.167-.319l25.161.485.111,7.149-25.139.618c-.921,0-1.719-.445-1.719-1.068v-6.056A.9.9,0,0,1,2780.554,2747.048Z",
    transform: "translate(-2780.135 -2690.131)",
    fill: "#7d7d7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61112",
    "data-name": "Group 61112",
    transform: "translate(2.022 22.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221352",
    "data-name": "Path 221352",
    d: "M2781.588,2258.111l3.63-14.4a1.186,1.186,0,0,1,1.094-.912h14.2a1.236,1.236,0,0,1,1.127,1.253l-.34,11.529a1.136,1.136,0,0,1-.948,1.088l-17.489,2.829a1.126,1.126,0,0,1-1.274-1.386Z",
    transform: "translate(-2776.899 -2242.686)",
    fill: "#7d7d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221353",
    "data-name": "Path 221353",
    d: "M3055.108,2241.145l.185.031a1.128,1.128,0,0,1,.9,1.406l-3.957,14.717a1.128,1.128,0,0,1-1.3.815l-1.25-.234Z",
    transform: "translate(-3049.694 -2241.145)",
    fill: "#7d7d7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_221354",
    "data-name": "Path 221354",
    d: "M2785.548,2503.758a1.066,1.066,0,0,0,1.066,1.067h4.444a1.067,1.067,0,0,0,1.067-1.067v-.533a1.067,1.067,0,0,0-1.067-1.067h-4.444a1.067,1.067,0,0,0-1.066,1.067Z",
    transform: "translate(-2765.636 -2462.157)",
    fill: "#7d7d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221355",
    "data-name": "Path 221355",
    d: "M2699.035,2012.365a1.614,1.614,0,0,1,1.138.348,1.458,1.458,0,0,1,.545.987v11.632h-14.724S2686.785,2013.258,2699.035,2012.365Z",
    transform: "translate(-2667.472 -2005.598)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61114",
    "data-name": "Group 61114",
    transform: "translate(6.709 52.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61113",
    "data-name": "Group 61113"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1678",
    "data-name": "Ellipse 1678",
    cx: 11.441,
    cy: 11.441,
    rx: 11.441,
    ry: 11.441,
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1679",
    "data-name": "Ellipse 1679",
    cx: 9.292,
    cy: 9.292,
    rx: 9.292,
    ry: 9.292,
    transform: "matrix(-0.984, -0.178, 0.178, -0.984, 18.922, 22.255)",
    fill: "#dddbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221356",
    "data-name": "Path 221356",
    d: "M2850.108,2749.529a.224.224,0,0,0,.088-.018.227.227,0,0,0,.12-.3,8,8,0,0,1,11.277-10.1.227.227,0,0,0,.221-.4,8.457,8.457,0,0,0-11.915,10.669A.227.227,0,0,0,2850.108,2749.529Z",
    transform: "translate(-2846.471 -2734.66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1680",
    "data-name": "Ellipse 1680",
    cx: 4.261,
    cy: 4.261,
    rx: 4.261,
    ry: 4.261,
    transform: "translate(7.18 7.18)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61116",
    "data-name": "Group 61116",
    transform: "translate(77.248 52.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61115",
    "data-name": "Group 61115"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1681",
    "data-name": "Ellipse 1681",
    cx: 11.441,
    cy: 11.441,
    rx: 11.441,
    ry: 11.441,
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1682",
    "data-name": "Ellipse 1682",
    cx: 9.292,
    cy: 9.291,
    rx: 9.292,
    ry: 9.291,
    transform: "matrix(-0.987, -0.16, 0.16, -0.987, 19.119, 22.101)",
    fill: "#dddbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221357",
    "data-name": "Path 221357",
    d: "M1810.654,2749.529a.226.226,0,0,0,.208-.314,8,8,0,0,1,11.277-10.1.227.227,0,0,0,.222-.4,8.457,8.457,0,0,0-11.915,10.669A.227.227,0,0,0,1810.654,2749.529Z",
    transform: "translate(-1807.017 -2734.66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1683",
    "data-name": "Ellipse 1683",
    cx: 4.261,
    cy: 4.261,
    rx: 4.261,
    ry: 4.261,
    transform: "translate(7.18 7.18)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61118",
    "data-name": "Group 61118",
    transform: "translate(103.42 52.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61117",
    "data-name": "Group 61117"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1684",
    "data-name": "Ellipse 1684",
    cx: 11.441,
    cy: 11.441,
    rx: 11.441,
    ry: 11.441,
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1685",
    "data-name": "Ellipse 1685",
    cx: 9.291,
    cy: 9.291,
    rx: 9.291,
    ry: 9.291,
    transform: "translate(2.15 2.15)",
    fill: "#dddbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221358",
    "data-name": "Path 221358",
    d: "M1424.978,2749.529a.223.223,0,0,0,.088-.018.227.227,0,0,0,.12-.3,8,8,0,0,1,11.277-10.1.227.227,0,0,0,.221-.4,8.456,8.456,0,0,0-11.915,10.669A.226.226,0,0,0,1424.978,2749.529Z",
    transform: "translate(-1421.341 -2734.66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1686",
    "data-name": "Ellipse 1686",
    cx: 4.261,
    cy: 4.261,
    rx: 4.261,
    ry: 4.261,
    transform: "translate(7.18 7.18)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61119",
    "data-name": "Group 61119",
    transform: "translate(0.533 50.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221359",
    "data-name": "Path 221359",
    d: "M3092.066,2656.58a1.129,1.129,0,0,0,1.129,1.129h2.9a1.129,1.129,0,0,0,1.129-1.129v-3.964a1.13,1.13,0,0,0-1.129-1.129h-2.9a1.129,1.129,0,0,0-1.129,1.129Z",
    transform: "translate(-3092.066 -2651.487)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221360",
    "data-name": "Path 221360",
    d: "M3092.065,2651.487v5.867h.928a1.553,1.553,0,0,0,1.383-1.324v-3.715c0-.624-.761-.828-1.383-.828Z",
    transform: "translate(-3089.221 -2651.487)",
    fill: "#fff",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_221361",
    "data-name": "Path 221361",
    d: "M2711.7,2266.049a.226.226,0,0,0,.226-.227v-26.134a.226.226,0,0,0-.452,0v26.134A.226.226,0,0,0,2711.7,2266.049Z",
    transform: "translate(-2680.415 -2217.288)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221362",
    "data-name": "Path 221362",
    d: "M2702.832,2052.693a.226.226,0,0,0,.214-.153c3.381-9.8,10.357-9.1,10.428-9.095a.226.226,0,0,0,.053-.45c-.072-.009-7.4-.758-10.908,9.4a.226.226,0,0,0,.14.288A.222.222,0,0,0,2702.832,2052.693Z",
    transform: "translate(-2681.608 -2034.14)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61137",
    "data-name": "Group 61137",
    transform: "translate(156.84 44.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221437-2",
    "data-name": "Path 221437",
    d: "M1351.535,1253.414c0,1.6-2.9,7.47-2.9,7.47s-2.9-5.872-2.9-7.47a2.9,2.9,0,0,1,5.808,0Z",
    transform: "translate(-1345.727 -1250.52)",
    fill: "#b5b5b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221438-2",
    "data-name": "Path 221438",
    d: "M1358.519,1260.92a2.275,2.275,0,1,1-2.275-2.25A2.263,2.263,0,0,1,1358.519,1260.92Z",
    transform: "translate(-1353.34 -1257.988)",
    fill: "#f0f0f1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61138",
    "data-name": "Group 61138",
    transform: "translate(170.816 70.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221437-3",
    "data-name": "Path 221437",
    d: "M1351.535,1253.414c0,1.6-2.9,7.47-2.9,7.47s-2.9-5.872-2.9-7.47a2.9,2.9,0,0,1,5.808,0Z",
    transform: "translate(-1345.727 -1250.52)",
    fill: "#b5b5b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221438-3",
    "data-name": "Path 221438",
    d: "M1358.519,1260.92a2.275,2.275,0,1,1-2.275-2.25A2.263,2.263,0,0,1,1358.519,1260.92Z",
    transform: "translate(-1353.34 -1257.988)",
    fill: "#f0f0f1",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadoutSelectOption);
export default __webpack_public_path__ + "static/media/loadoutSelectOption.6a27a1b687c5cdcff36ee65d23fe7d32.svg";
export { ForwardRef as ReactComponent };